import { POSITIONS, THROW_TARGETS } from "../constants";

// ── Diamond ────────────────────────────────────────────────────────────────

const FIELD_GREEN = "#173626";
const DIRT_TAN     = "#c9a06c";
const DIRT_STROKE  = "#a3803f";
const BASE_FILL    = "#f6f2e8";
const BOUNDARY     = "rgba(255,255,255,0.32)";
const RUNNER_RED   = "#e5484d";
const FONT_STACK    = "'Helvetica Neue', Arial, sans-serif";

const BASES = [{ cx:70, cy:55, id:"first" }, { cx:50, cy:35, id:"second" }, { cx:30, cy:55, id:"third" }];

export function Diamond({ mode="view", runners=[], highlightPos=null, onPosClick, onTargetClick, selectedTarget, correctTarget, submitted, size=260 }) {
  const markers = mode==="throw" ? THROW_TARGETS : POSITIONS;
  return (
    <svg viewBox="0 0 100 100" style={{display:"block",width:"100%",maxWidth:size,height:"auto",margin:"0 auto",flexShrink:0}}>
      <defs>
        <filter id="diamondShadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="0.6" stdDeviation="0.7" floodColor="#000" floodOpacity="0.4"/>
        </filter>
      </defs>

      <rect width="100" height="100" fill={FIELD_GREEN} rx="4"/>
      <circle cx="50" cy="50" r="46" fill="none" stroke={BOUNDARY} strokeWidth="0.6"/>
      <line x1="50" y1="83" x2="3" y2="3" stroke={BOUNDARY} strokeWidth="0.6"/>
      <line x1="50" y1="83" x2="97" y2="3" stroke={BOUNDARY} strokeWidth="0.6"/>

      {/* infield dirt with grass diamond cut out */}
      <circle cx="50" cy="57" r="29" fill={DIRT_TAN}/>
      <polygon points="50,34 74,57 50,80 26,57" fill={FIELD_GREEN}/>
      <circle cx="50" cy="58" r="3" fill={DIRT_TAN} stroke={DIRT_STROKE} strokeWidth="0.4"/>

      {/* bases */}
      {BASES.map(({cx,cy,id})=>{
        const occupied=(runners||[]).includes(id);
        return (
          <g key={id}>
            <rect x={cx-3} y={cy-3} width="6" height="6" fill={BASE_FILL} stroke="rgba(0,0,0,0.25)" strokeWidth="0.4" transform={`rotate(45,${cx},${cy})`} filter="url(#diamondShadow)"/>
            {occupied && <circle cx={cx} cy={cy} r="2.6" fill={RUNNER_RED} filter="url(#diamondShadow)"/>}
          </g>
        );
      })}

      {/* position markers */}
      {markers.map(p=>{
        const isMe=p.id===highlightPos, isSel=mode==="throw"&&selectedTarget===p.id;
        const isOk=mode==="throw"&&submitted&&p.id===correctTarget, isBad=mode==="throw"&&submitted&&isSel&&p.id!==correctTarget;
        let fill=BASE_FILL, stroke="rgba(0,0,0,0.12)", tc="#111";
        if(isMe&&mode!=="throw"){fill="#1FD71D";stroke="#14a616";}
        if(isMe&&mode==="throw"){fill="#2f7bdb";stroke="#1a5cae";tc="#fff";}
        if(isSel&&!submitted){fill="#1FD71D";stroke="#14a616";}
        if(isOk){fill="#43a047";stroke="#2e7d32";tc="#fff";}
        if(isBad){fill=RUNNER_RED;stroke="#b71c1c";tc="#fff";}
        const r=mode==="throw"?7.5:6.5, isCatcher=p.id==="C", clickable=mode==="select"||(mode==="throw"&&!isMe&&!submitted);
        return (
          <g key={p.id} onClick={()=>{if(mode==="select")onPosClick?.(p);if(mode==="throw"&&!isMe&&!submitted)onTargetClick?.(p.id);}} style={{cursor:clickable?"pointer":"default"}}>
            {isCatcher && <circle cx={p.x} cy={p.y} r={r+2.2} fill="none" stroke={fill} strokeWidth="0.8" opacity="0.7"/>}
            <circle cx={p.x} cy={p.y} r={r} fill={fill} stroke={stroke} strokeWidth="0.8" filter="url(#diamondShadow)"/>
            <text x={p.x} y={p.y+1.2} textAnchor="middle" dominantBaseline="middle" fontSize={mode==="throw"?"3.6":"3"} fill={tc} fontWeight="800" style={{pointerEvents:"none",fontFamily:FONT_STACK}}>{p.short}</text>
            {mode==="throw"&&!isMe&&<text x={p.x} y={p.y+r+3.8} textAnchor="middle" fontSize="2.4" fill="rgba(255,255,255,0.7)" style={{pointerEvents:"none",fontFamily:FONT_STACK}}>{p.label}</text>}
          </g>
        );
      })}
    </svg>
  );
}
